if (!customElements.get('adev-card-images')) {
    customElements.define('adev-card-images', class adevCardImages extends HTMLElement {
        constructor() {
            super();
        }
        
        
        initSlider(){
            this.sliderEl = new Flickity(this, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: true,
                initialIndex: this.dataset.initialIndex ? parseInt(this.dataset.initialIndex, 10) : 0,
            });
        }

        destroySlider(){
            if(this.sliderEl){
                this.sliderEl.destroy();
            }
        }

        updateCurrentMedia(index){
            if(this.sliderEl){
                this.sliderEl.select(index);
            }
        }

        connectedCallback() {
            this.initSlider();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

    });
}